/**
 *  Copyright (c) 2022-present TVM Engineering Authors.
 *
 */
/* eslint-disable */
import types from "../actions/types";

const userFromCookie = sessionStorage.getItem("user");
const user = JSON.parse(userFromCookie);

const INITIAL_STATE = {
  error: "",
  message: "",
  content: "",
  isAuthenticated: false,
  token: "",
  userId: null,
  user,
};

export default function authReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case types.SIGN_IN:
      const object = {
        ...state,
        error: null,
        message: action.message || "",
        token: action.user.token,
        userId: action.user.user.id,
        user: action.user,
      };

      return object;

    case types.SIGN_IN_ERROR:
      return {
        ...state,
        status: action.status,
        error: action.error,
        message: action.message,
      };
    case types.AUTH_USER:
      // console.log('AUTH_USER', state);
      if (state.user && state.user.token === action.user.token) {
        return {
          ...state,
          error: null,
          message: action.message,
          isAuthenticated: true,
          user: action.user,
        };
      }
      return {
        ...state,
        isAuthenticated: false,
        user: action.user,
      };
    case types.UNAUTH_USER:
      return { ...state, isAuthenticated: false, error: action.error };
    case types.AUTH_ERROR:
      return { ...state, error: action.payload };
    case types.FORGOT_PASSWORD_REQUEST:
      return { ...state, message: action.payload.message };
    case types.SET_ROUTES:
      return { ...state, routes: action.payload.routes };
    case types.RESET_PASSWORD_REQUEST:
      return { ...state, message: action.payload.message };
    case types.PROTECTED_TEST:
      return { ...state, content: action.payload.message };
    default:
      return state;
  }
}

// Selectors
export const getUserData = (state) => state.auth.user;
export const getUserId = (state) => state.auth.user.user.id;
export const getRoutes = (state: Object) => state.app.routes;
export const getAuthentication = (state) => state.auth.isAuthenticated;
export const isAuthenticated = (state) => state.auth.isAuthenticated;
export const getErrorMessage = (state) => state.auth.error;
